/**
 * Enum used by fetch to determine if
 * a fetch was initiated by the backgroundFetcher
 */
export enum FetchType {
  BackgroundTask,
  UserInitiatedTask,
}
